import React from "react";

function MotorIcon({ style }: any) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M5.25 3V4.5H7.5V6H5.25L3.75 7.5V9.75H2.25V7.5H0.75V13.5H2.25V11.25H3.75V13.5H6L7.5 15H13.5V12H15V14.25H17.25V6.75H15V9H13.5V6H9V4.5H11.25V3H5.25Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default MotorIcon;
